import { render, staticRenderFns } from "./product-custom-field.vue?vue&type=template&id=4cf11725"
import script from "./product-custom-field.vue?vue&type=script&lang=js"
export * from "./product-custom-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports